import logo from "../../../../../assets/images/coachTeamLogo.png";

export const UpcomingGamesCarousel = ({ games }) => (
  <div className="rounded-3xl bg-slate-900/80 p-3">
    <p className="text-[11px] text-slate-300 mb-2 text-left">
      The following games coming soon
    </p>
    <div className="flex gap-3 overflow-x-auto pb-1">
      {games.map((g) => (
        <div
          key={g.id}
          className={`min-w-[180px] rounded-2xl ${
            g.isLive
              ? 'bg-gradient-to-r from-red-600/70 to-red-800/90 border-2 border-red-500/50'
              : 'bg-gradient-to-r from-sky-700/60 to-slate-900/90'
          } p-3 flex flex-col items-center justify-between relative`}
        >
          {/* LIVE Badge */}
          {g.isLive && (
            <div className="absolute top-2 right-2 bg-red-600 text-white text-[9px] font-bold px-2 py-0.5 rounded-full flex items-center gap-1">
              <span className="w-1.5 h-1.5 bg-white rounded-full animate-pulse"></span>
              LIVE
            </div>
          )}

          <div className="flex items-center justify-between w-full mb-3">
            <img
              src={g.homeLogo || logo}
              alt=""
              className="w-8 h-8 rounded-full object-cover"
            />
            <span className="text-xs text-white font-semibold">VS</span>
            <img
              src={g.awayLogo || logo}
              alt=""
              className="w-8 h-8 rounded-full object-cover"
            />
          </div>

          <div className="text-[10px] text-slate-200 text-center w-full">
            {/* Team Names */}
            <div className="font-semibold text-white mb-1 truncate">{g.home}</div>
            <div className="text-slate-300 mb-2 truncate">{g.away}</div>

            {/* Location and Date */}
            <div className="font-semibold text-slate-300">{g.location}</div>
            <div className="text-slate-400">{g.date}</div>

            {/* Time Remaining or Live Status */}
            {g.isLive ? (
              <div className="mt-2 text-red-300 font-bold text-[11px] animate-pulse">
                MATCH IN PROGRESS
              </div>
            ) : g.timeRemaining ? (
              <div className="mt-2 bg-sky-600/50 text-white font-semibold px-2 py-1 rounded text-[11px]">
                Starts in {g.timeRemaining}
              </div>
            ) : null}
          </div>
        </div>
      ))}
    </div>
  </div>
);
